export default "__VITE_ASSET__CwfH4SMI__"